import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

export const InstanciatedQueryClientProvider: React.FC = ({ children }) => {
  const [queryClient] = useState(() => new QueryClient());

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
